export const contactsData = {
  email: "hagerk720@gmail.com",
  phone: "+201144342836",
  address: "Alexandria , Egypt ",
  github: "https://github.com/hagerk720",
  linkedIn: "https://www.linkedin.com/in/hager-khaled",
};
